
import React from 'react';
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip';
import { Bot, FileText, BarChart, Webhook } from 'lucide-react';
import NavigationItem from './NavigationItem';

interface IntegrationsSectionContentProps {
  activeTab: string;
  onChange: (value: string) => void;
}

const IntegrationsSectionContent = ({ 
  activeTab, 
  onChange 
}: IntegrationsSectionContentProps) => {
  return (
    <>
      <Tooltip>
        <TooltipTrigger asChild>
          <div>
            <NavigationItem 
              active={activeTab === 'ai'} 
              onClick={() => onChange('ai')}
              icon={<Bot className="h-4 w-4 mr-2" />}
              label="AI & LLM"
            />
          </div>
        </TooltipTrigger>
        <TooltipContent side="right">
          <p className="max-w-xs">Configure AI/LLM integration for insights and automation</p>
        </TooltipContent>
      </Tooltip>
      
      <Tooltip>
        <TooltipTrigger asChild>
          <div>
            <NavigationItem 
              active={activeTab === 'billing'} 
              onClick={() => onChange('billing')}
              icon={<FileText className="h-4 w-4 mr-2" />}
              label="Tariff & Billing"
            />
          </div>
        </TooltipTrigger>
        <TooltipContent side="right">
          <p className="max-w-xs">Configure tariff profiles and billing settings</p>
        </TooltipContent>
      </Tooltip>
      
      <Tooltip>
        <TooltipTrigger asChild>
          <div>
            <NavigationItem 
              active={activeTab === 'sustainability'} 
              onClick={() => onChange('sustainability')}
              icon={<BarChart className="h-4 w-4 mr-2" />}
              label="Sustainability"
            />
          </div>
        </TooltipTrigger>
        <TooltipContent side="right">
          <p className="max-w-xs">Configure sustainability and ESG reporting</p>
        </TooltipContent>
      </Tooltip>
      
      <Tooltip>
        <TooltipTrigger asChild>
          <div>
            <NavigationItem 
              active={activeTab === 'webhooks'} 
              onClick={() => onChange('webhooks')}
              icon={<Webhook className="h-4 w-4 mr-2" />}
              label="Webhooks & APIs"
            />
          </div>
        </TooltipTrigger>
        <TooltipContent side="right">
          <p className="max-w-xs">Configure third-party API integrations and webhooks</p>
        </TooltipContent>
      </Tooltip>
    </>
  );
};

export default IntegrationsSectionContent;
